import i18next from '@bonanza-social/i18n';
import en from './en.json';
import fr from './fr.json';

i18next.addResources('en', 'geoFence', en);
i18next.addResources('fr', 'geoFence', fr);

declare global {
  interface RegisteredLocales {
    geoFence: typeof en;
  }
}
